<template>
    <div>
        <b-modal
          :model-value="InactivaItem"
          :no-close-on-backdrop="true"
          hide-footer
          hide-header-close
          centered
          :title="labels.title"
          header-class="reset-modal-header"
          title-class="reset-modal-title"
          body-class="reset-modal-body"
          class="reset-password-dialog"
        >
            <div class="uniform-modal-body">
                <div class="password-policy-box mb-3">
                    <div class="password-policy-title">{{ labels.title }}</div>
                    <div class="password-policy-item">{{ labels.texto }}</div>
                </div>
                <div class="reset-dialog-actions d-flex justify-content-end mt-3 uniform-actions-wrap">
                    <b-button class="mr-2 reset-btn-secondary" @click="cancelDelete">{{ labels.cancelar }}</b-button>
                    <b-button class="reset-btn-primary" @click="confirmDelete">{{ labels.aceptar }}</b-button>
                </div>
            </div>
        </b-modal>
    </div>
</template>
<script>
export default {
    name: 'DialogConfirm',
    props: ['InactivaItem','borraReg'],
    data: () => ({
      
    }),
    computed:{
        labels(){
            if (this.$store.state._language == "es-ES") { 
                return {
                    title: "Inactivar y/o Eliminar Registro",
                    texto : "¿Seguro desea Inactivar y/o Eliminar este registro?",
                    aceptar : "Aceptar",
                    cancelar : "Cancelar"
                }
            }else{
                return {
                    title: "Inactivate Row",
                    texto : "Are you sure you want to inactivate this record?",
                    aceptar : "Accept",
                    cancelar : "Cancel"
                }
            }
        }
    },
    methods: {
        cancelDelete(){
            this.$emit('cierraModal', false); 
        },
        confirmDelete(){
            this.$emit('confirmDelete'); 
        }
    }
}
</script>
